import { ChangeDetectionStrategy, Component, DestroyRef, inject, type OnInit, signal, type WritableSignal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { AuthContext } from ':core/context/auth.context';
import { SvgIcon } from ':shared/enums';
import { isJwtTokenInLocalStorage } from ':shared/utils/jwt-token-local-storage-functions';
import { isMalouUserIdentityInLocalStorage } from ':shared/utils/manage-user-uuid';

@Component({
    selector: 'app-global-banner',
    templateUrl: './global-information-banner.component.html',
    styleUrls: ['./global-information-banner.component.scss'],
    imports: [MatIconModule, TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GlobalInformationBannerComponent implements OnInit {
    private readonly _router = inject(Router);
    private readonly _authContext = inject(AuthContext);
    private readonly _destroyRef = inject(DestroyRef);

    readonly SvgIcon = SvgIcon;

    readonly shouldShowNotLoggedInInformation: WritableSignal<boolean> = signal(false);

    ngOnInit(): void {
        this._authContext.isTokenValid$.pipe(takeUntilDestroyed(this._destroyRef)).subscribe((isTokenValid) => {
            this.shouldShowNotLoggedInInformation.set(!isTokenValid && isMalouUserIdentityInLocalStorage() && !isJwtTokenInLocalStorage());
        });
    }

    redirectToLogin(): void {
        this._router.navigate(['/login']);
    }
}
